import { useEffect, useRef } from "react";

export function useNotificationTitleIndicator() {
  const originalTitleRef = useRef(document.title);

  useEffect(() => {
    originalTitleRef.current = document.title;

    const removeIndicator = () => {
      const t = document.title;
      if (t.startsWith("(*) ")) {
        document.title = t.slice(4);
      }
    };

    const onMessage = (e: MessageEvent) => {
      if (e.data?.type !== "NEW_NOTIFICATION") return;
      if (!document.title.startsWith("(*) ")) {
        document.title = `(*) ${document.title}`;
      }
    };

    const onVisibility = () => {
      if (!document.hidden) removeIndicator();
    };

    navigator.serviceWorker?.addEventListener("message", onMessage);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      navigator.serviceWorker?.removeEventListener("message", onMessage);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
}
